var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ConfirmAccountForm',{on:{"confirmAccount":_vm.confirm,"createAnAccountButton":_vm.createAnAccountButton},model:{value:(_vm.confirmAccountModel),callback:function ($$v) {_vm.confirmAccountModel=$$v},expression:"confirmAccountModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }